/*const VISIBILITY_FILTERS = {
  ALL: "all",
  COMPLETED: "completed",
  INCOMPLETE: "incomplete"
};*/

export default {

  cart_count: ({ cart_items = [] }) => cart_items.length || 0,

  cart_total: ({ cart_items = [] }) => cart_items.reduce((prev,cur) => {
    const price = cur.pricing.price || 0;
    return prev + (cur.quantity * price);
  }, 0),

  get_items_by_id: (items=[],from=0,to=0) => {
    return items.filter((a,i) => (i>=from-1 && i<=to-1));
  },

  get_category_by_title: (data=[], title='') => {
    return data.filter((a) => a.title===title);
  },

  /*getTodosState: store => store.todos,

  getTodoList: store => getTodosState(store) ? getTodosState(store).allIds : [],

  getTodoById: (store, id) =>
    getTodosState(store) ? { ...getTodosState(store).byIds[id], id } : {},

  /**
   * example of a slightly more complex selector
   * select from store combining information from multiple reducers
   */
  /*getTodos: store => getTodoList(store).map(id => getTodoById(store, id)),

  getTodosByVisibilityFilter: (store, visibilityFilter) => {
    const allTodos = getTodos(store);
    switch (visibilityFilter) {
      case VISIBILITY_FILTERS.COMPLETED:
        return allTodos.filter(todo => todo.completed);
      case VISIBILITY_FILTERS.INCOMPLETE:
        return allTodos.filter(todo => !todo.completed);
      case VISIBILITY_FILTERS.ALL:
      default:
        return allTodos;
    }
  }*/

}
